import React from "react"
import styled from "styled-components"
import { theme } from "@op-str/op-component-library"

// Used to display "WYSIWYG" butter cms fields
export const HtmlContainer = styled.div`
  font-size: ${theme.fontSize.m};

  ul,
  ol {
    padding-left: 16px;
  }

  a,
  a > strong {
    font-family: ${theme.font.bold};
    color: ${theme.color.primary};
    text-decoration: none;
    font-weight: inherit;
    transition: color 0.3s linear;

    &:hover {
      text-decoration: underline;
      color: ${theme.color.blue1};
    }
  }
`
